var exports = {
  "WB": "PersonalNotesWelcomeSection.module__welcomeSection___aWYwQU",
  "H": "PersonalNotesWelcomeSection.module__avatarContainer___aWYwQU",
  "oJ": "PersonalNotesWelcomeSection.module__avatarBackground___aWYwQU",
  "my": "PersonalNotesWelcomeSection.module__avatar___aWYwQU",
  "DD": "PersonalNotesWelcomeSection.module__title___aWYwQU",
  "fF": "PersonalNotesWelcomeSection.module__dividerContainer___aWYwQU",
  "K8": "PersonalNotesWelcomeSection.module__dividerSvg___aWYwQU",
  "h_": "PersonalNotesWelcomeSection.module__description___aWYwQU",
};

module.exports = exports;
